import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { State } from './settings.state';
import { OverlayContainer } from '@angular/cdk/overlay';
import { select, Store } from '@ngrx/store';
import { merge, of } from 'rxjs';
import { tap, withLatestFrom } from 'rxjs/operators';

import { selectSettingsState } from './settings.selectors';

import { actionSettingsChangeTheme } from './settings.actions';

import { selectEffectiveTheme } from './settings.selectors';
import { StateLocalStorageService } from '../../services/state-local-storage.service';

export const SETTINGS_KEY = 'settings';
const INIT = of('vntg-init-effect-trigger');
const THEME_CLASS_PREFIXES = ['custom-', 'peregrine-default-'];
const THEME_CLASSES = ['light-theme', 'dark-theme', 'opus-1'];

export function isThemeClass(className: string): boolean {
  return THEME_CLASSES.includes(className) || THEME_CLASS_PREFIXES.some((prefix) => className.startsWith(prefix));
}

@Injectable()
export class SettingsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private overlayContainer: OverlayContainer,
    private localStorageService: StateLocalStorageService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  persistSettings = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actionSettingsChangeTheme),
        withLatestFrom(this.store.pipe(select(selectSettingsState))),
        tap(([action, settings]) => this.localStorageService.setItem(SETTINGS_KEY, settings))
      ),
    { dispatch: false }
  );
  updateTheme = createEffect(
    () =>
      merge(INIT, this.actions$.pipe(ofType(actionSettingsChangeTheme))).pipe(
        withLatestFrom(this.store.pipe(select(selectEffectiveTheme))),
        tap(([action, effectiveTheme]) => {
          this.setThemeClass(this.overlayContainer.getContainerElement().classList, effectiveTheme);
          this.setThemeClass(this.document.body.classList, effectiveTheme);
        })
      ),
    { dispatch: false }
  );

  private setThemeClass(classList: DOMTokenList, effectiveTheme: string) {
    const toRemove = Array.from(classList).filter((item: string) => isThemeClass(item));
    if (toRemove.length) {
      classList.remove(...toRemove);
    }
    classList.add(effectiveTheme);
  }
}
